import Service from "../AuthService";

const CancelReason = {
    CancelReason() {
        return Service.get(`cancel-reason`);
    },
    getSetting() {
        return Service.get(`settings/cancel-reasons`);
    },
    createSetting(payload, token) {
        return Service.post(`settings/cancel-reasons?token=${token}`, payload);
    },
    updateSetting(payload, id, token) {
        return Service.put(`settings/cancel-reasons/${id}?token=${token}`, payload)
    },
    deleteSetting(id, token) {
        return Service.delete(`settings/cancel-reasons/${id}?token=${token}`);
    }
};

export default CancelReason;
